import React from 'react';
import { Box } from '@mui/material';
import { LANDING_FONT, LC, r } from './landingTokens';

// "my" (regular) + "Stack" (black) weight-contrast wordmark.
// onDark: mint + white. onLight: accent + evergreen.
export default function Wordmark({ size = 22, variant = 'onDark', sx }) {
  const my = variant === 'onLight' ? LC.accent : LC.mint;
  const stack = variant === 'onLight' ? LC.evergreen : 'primary.contrastText';
  return (
    <Box
      component="span"
      sx={{
        fontFamily: LANDING_FONT,
        fontSize: r(size),
        letterSpacing: '-0.03em',
        lineHeight: 1,
        ...sx,
      }}
    >
      <Box component="span" sx={{ fontWeight: 400, color: my }}>my</Box>
      <Box component="span" sx={{ fontWeight: 800, color: stack }}>Stack</Box>
    </Box>
  );
}
